<template>
  <div id="viewer">
    <b-container>
      <h4>Visor de contrato</h4>
      <iframe id="pdfV" style="width:100%; height: 500px"></iframe>
    </b-container>
  </div>
</template>

<script>
import fireStore from "../../helpers/db";
import contratoArriendo from "../../contractTemplates/arriendo.js";

export default {
  computed: {
    email() {
      return !this.$store.getters.user ? "" : this.$store.getters.user.email;
    },
    name() {
      return !this.$store.getters.userInfo
        ? ""
        : this.$store.getters.userInfo.name;
    },
    contract() {
      return this.$store.getters.contracts.find(
        c => (c.docId == this.$store.state.activeContract)
      );
    }
  },
  methods: {
    goToArriendo() {
      console.log("Entro al boton arriendo");
      this.$store.dispatch("goToArriendo");
    }
  },
  created() {
    console.log("Entro al viewer " + this.contract.docId);
    var e = new contratoArriendo(this.contract);
    pdfMake.createPdf(e.getContractObject()).getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
  },
  beforeDestroy() {
    console.log("salio del viewer");
    // this.$store.commit('clearActiveContract');
  }
};
</script>

<style scoped>
#dashboard {
  padding-left: 3%;
  padding-right: 3%;
}
h1 {
  text-align: left;
}
.contratos {
  text-align: left;
  padding-left: 10%;
}
.pastContracts {
  text-align: left;
  padding-top: 20px;
}

.button-contract {
  border: 1px solid #3b3b3b;
  color: #3b3b3b;
  padding: 10px 20px;
  font: inherit;
  cursor: pointer;
  margin-top: 10px;
  width: 280px;
}

#viewer {
  padding-top: 20px;
  /* margin-top: 20px; */
}
</style>


// WEBPACK FOOTER //
// src/components/contractView/contractViewer.vue